import styled from '@emotion/styled';
import AttenderA from '@assets/svg/attender_a.svg';
import AttenderLogo from '@assets/svg/logo.svg';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';

export const LogoLink = styled.div`
  cursor: pointer;
  height: 100%;
  height: 30px;
  display: block;
  margin-right: auto;
`;

export const DesktopLogo = styled(AttenderLogo)`
  height: 30px;
  width: auto;

  ${mq(Devices.tablet)} {
    display: none;
  }
`;

export const MobileLogo = styled(AttenderA)`
  height: 30px;
  width: auto;
  display: none;

  ${mq(Devices.tablet)} {
    display: block;
  }
`;
